import { Stack } from '@mui/material';
import { TypedOptionsTable } from './TypedOptionsTable';

export function LocationOptions() {
  return (
    <Stack direction="row" spacing={1} sx={{ p: 1 }}>
      <title>IR3 | Location Options</title>
      <TypedOptionsTable name="locationGroup" title="Categories" />
    </Stack>
  );
}
